import isNil from 'lodash/isNil'
import toNumber from 'lodash/toNumber'

// A form's default numeric updater coerces via lodash `toNumber`, and `toNumber('') === 0` —
// clearing a nullable numeric field would otherwise send `0` (a real, priced value), not "unset".
// Use this wherever an emptied numeric field must send `null` instead of `0`.
export const toNullableNumber = (value: number | string): number | null =>
  isNil(value) || value === '' ? null : toNumber(value)
